const DEFAULT_PROXY_URL = process.env.REACT_APP_PROXY_URL || 'http://localhost:3001/api';

export const SHOPIFY_STORE_NAME = process.env.REACT_APP_SHOPIFY_STORE_NAME || 'shopify';

export const API_CONFIG = {
    PROXY_URL: DEFAULT_PROXY_URL,
    TIMEOUT: Number(process.env.REACT_APP_API_TIMEOUT) || 100000,
    SHOPIFY_PUBLISH_BATCH_SIZE: Math.max(
        Number(process.env.REACT_APP_SHOPIFY_PUBLISH_BATCH_SIZE) || 10,
        1,
    ),
    SHOPIFY_PUBLISH_BATCH_DELAY_MS: Math.max(
        Number(process.env.REACT_APP_SHOPIFY_PUBLISH_BATCH_DELAY_MS) || 1500,
        0,
    ),
    GMC_PUBLISH_BATCH_SIZE: Math.max(
        Number(process.env.REACT_APP_GMC_PUBLISH_BATCH_SIZE) || 10,
        1,
    ),
    GMC_PUBLISH_BATCH_DELAY_MS: Math.max(
        Number(process.env.REACT_APP_GMC_PUBLISH_BATCH_DELAY_MS) || 1000,
        0,
    ),
    ENABLE_PRODUCT_SYNC: true,
    ENABLE_PROFILE_SYNC: true,
    ENABLE_AI_FALLBACK:
        (process.env.REACT_APP_ENABLE_AI_FALLBACK || 'false').toLowerCase() === 'true',
};

export const AI_DEFAULTS = {
    model: 'gpt-5.4',
    maxTokens: 1000,
    temperature: 0.7,
};

export const ERROR_MESSAGES = {
    PRODUCT_SYNC_FAILED: 'Product sync failed. Using the demo catalog instead.',
    PRODUCT_SYNC_EMPTY: 'The product sync returned no products. Using the demo catalog instead.',
    PROFILE_LOAD_FAILED: 'Profile sync failed. Using local defaults instead.',
    PROFILE_SAVE_FAILED: 'Could not save the profile. Check your network connection and try again.',
    PROFILE_DELETE_FAILED: 'Could not delete the profile. Check your network connection and try again.',
    AI_GENERATION_FAILED: 'AI request failed. Try again or check the server configuration.',
    AI_API_KEY_MISSING: 'The AI service is not configured on the server.',
    CLIPBOARD_UNAVAILABLE: 'Clipboard access is unavailable in this browser. Try using Ctrl+C instead.',
    NETWORK_ERROR: 'Network request failed. Check your internet connection and try again.',
};
